// eslint-disable-next-line func-names
(function (Drupal, $) {
  const initToggleSidebar = (el) => {
    const $toggler = $(el);
    const targetID = $toggler.data('target');
    const $sidebar = $(`#${targetID}`);
    const $overlay = $('.overlay');

    if (!$sidebar.length) {
      return;
    }

    const handleUsingEscKey = (e) => {
      const key = e.key || e.keyCode;
      if (key === 27 || key === 'Escape') {
        const { closeSidebar } = e.data;

        if (closeSidebar) {
          closeSidebar(e);
        }
      }
    };

    const closeSidebar = (e) => {
      const { sidebar, overlay } = e.data;

      sidebar.attr('data-expanded', false);
      sidebar.removeClass('is-open');

      overlay.removeClass('is-open');
      localStorage.removeItem(sidebar.attr('id'));

      overlay.off('click', closeSidebar);
      $('body').removeClass(['overflow-hidden']);

      $(document).off('keydown', handleUsingEscKey);
    };

    const openSidebar = (sidebar, overlay, animate = true) => {
      sidebar.addClass('is-open');
      $('body').addClass(['overflow-hidden']);

      localStorage.setItem(sidebar.attr('id'), 'opened');

      sidebar.attr({ 'data-expanded': true });

      if (!animate) {
        sidebar.css({ transition: 'none' });
      }

      overlay.addClass('is-open');
      overlay.on('click', { sidebar, overlay }, closeSidebar);
      $(document).on('keydown', { sidebar, overlay, closeSidebar }, handleUsingEscKey);
    };

    $toggler.on('click keypress', () => {
      if ($toggler.data('action').includes('hide')) {
        closeSidebar({ data: { sidebar: $sidebar, overlay: $overlay } });
        return;
      }

      if ($toggler.data('action').includes('show')) {
        openSidebar($sidebar, $overlay);
      }
    });

    $(document).ajaxComplete((event, xhr, settings) => {
      if (targetID !== 'calendar-filter-sidebar' && !settings.data.includes('view_name=calender')) {
        return;
      }

      if (localStorage.getItem(targetID) === 'opened') {
        openSidebar($sidebar, $overlay, false);
      }
    });

    const sidebarHtml = $sidebar.get(0);

    if (sidebarHtml) {
      const config = { attributes: true };

      const callback = (mutationList) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-expanded') {
            if (sidebarHtml.dataset.expanded === 'true') {
              if ($toggler.data('action').includes('hide')) {
                $toggler.removeAttr('tabindex');
              }

              setTimeout(() => {
                sidebarHtml.style.transition = null;
                sidebarHtml.focus();
              }, 300);
            } else if ($toggler.data('action').includes('hide')) {
              $toggler.attr('tabindex', '-1');
            }
          }
        });
      };

      const observer = new MutationObserver(callback);

      observer.observe(sidebarHtml, config);
    }
  };
  Drupal.behaviors.mstToggleSidebar = {
    attach(context) {
      const $buttons = $(
        'button[data-action="hide-sidebar"], button[data-action="show-sidebar"]',
        context,
      );
      $buttons.each((index, el) => initToggleSidebar(el));
    },
  };
}(Drupal, jQuery));
